import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

// Get auth header for authenticated requests
export const getAuthHeader = () => {
  const token = localStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Setup axios interceptors
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const authService = {
  login: async (email, password) => {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      email,
      password,
    });
    return response.data;
  },

  register: async (userData) => {
    const payload = {
      email: userData.email,
      password: userData.password,
      confirmPassword: userData.confirmPassword ?? userData.password,
      phone: userData.phone,
      phoneCountryCode: userData.phoneCountryCode,
    };
    const response = await axios.post(`${API_BASE_URL}/auth/register`, payload);
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await axios.post(`${API_BASE_URL}/auth/refresh-token`, {
      refreshToken,
    });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, {
      email,
    });
    return response.data;
  },

  resetPassword: async (resetData) => {
    const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, resetData);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },

  registerGuest: async (email, password, firstName, lastName, phone) => {
    const response = await axios.post(`${API_BASE_URL}/auth/register-guest`, {
      email,
      password,
      firstName: firstName || 'Guest',
      lastName: lastName || 'User',
      phone,
    });
    return response.data;
  },
};

export default authService;

